import { Component, OnInit } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader-component.component.html',
  styleUrl: './loader-component.component.scss'
})
export class LoaderComponentComponent {
loading$ = this.loadingService.loading$;

  constructor(private loadingService: LoadingService) {

  }

}
